// extracted by css-extract-rspack-plugin
export default {"projectInfo":"NQkhucnUXNkBIlmh","projectInfoRow":"CvE3XnmHpA4TEiTT","projectInfoLabel":"Cz44AbcnDM0MkZiU"};